import { Check, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { COMPANION_BENEFITS, IMAGES } from "@/data/content";

export const BecomeCompanion = ({ onBook }) => (
  <section
    id="become-companion"
    data-testid="become-companion-section"
    className="relative overflow-hidden bg-navy py-24 lg:py-36"
  >
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-mauve/10 blur-3xl"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-sage/10 blur-3xl"
    />

    <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-2 lg:px-10">
      <div>
        <Reveal>
          <Eyebrow className="text-gold">Join Our Purpose</Eyebrow>
          <h2 className="mt-4 font-serif text-2xl leading-tight tracking-tight text-cream sm:text-3xl lg:text-4xl">
            Do you possess the gift of patient presence?
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-cream/70">
            We are seeking compassionate, articulate, and empathetic individuals across
            the UK who believe that spending time with an elder is one of life's highest
            privileges.
          </p>
        </Reveal>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2">
          {COMPANION_BENEFITS.map((benefit, i) => (
            <Reveal key={benefit} delay={i * 0.08}>
              <li
                data-testid={`companion-benefit-${i + 1}`}
                className="flex items-start gap-3 rounded-2xl border border-cream/10 bg-cream/[0.04] p-4 text-sm text-cream/85 backdrop-blur-sm"
              >
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/20 text-gold">
                  <Check className="h-3 w-3" aria-hidden="true" />
                </span>
                {benefit}
              </li>
            </Reveal>
          ))}
        </ul>

        <Reveal delay={0.3}>
          <button
            type="button"
            onClick={onBook}
            data-testid="become-companion-cta"
            className="group mt-10 inline-flex items-center gap-2 rounded-full bg-gold px-8 py-4 text-sm font-semibold text-navy shadow-elevated transition-all duration-300 hover:-translate-y-0.5 hover:bg-cream"
          >
            Apply to Become a Companion
            <ArrowRight
              className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
              aria-hidden="true"
            />
          </button>
        </Reveal>
      </div>

      <Reveal className="relative hidden lg:block" delay={0.15}>
        <div className="relative mx-auto max-w-sm">
          <div
            aria-hidden="true"
            className="absolute -inset-6 rounded-full bg-gradient-to-br from-gold/20 to-mauve/20 blur-2xl"
          />
          <div className="relative overflow-hidden rounded-full shadow-spotlight ring-1 ring-cream/15">
            <img
              src={IMAGES.tea}
              alt="A tranquil older woman enjoying a warm cup of tea beside floral arrangements"
              className="aspect-square w-full object-cover"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="absolute -bottom-4 left-1/2 w-max -translate-x-1/2 rounded-full border border-cream/10 bg-navy-muted px-6 py-3 text-center shadow-elevated">
            <p className="font-mono text-[0.6rem] font-semibold uppercase tracking-[0.25em] text-gold">
              Flexible · Rewarding · Human
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
